/*
 * @Author: LiGang
 * @Date: 2026-06-06 01:04:51
 * @LastEditors: LG ligang29@qq.com
 * @LastEditTime: 2026-10-13 16:37:02
 * @FilePath: /chezhu-h5/config/envsetting.js
 * @Description:
 *
 * Copyright (c) 2026 by ${git_name_email}, All Rights Reserved.
 */
// 测试
// export const parkcloudServerName = 'https://parkcloud.test.szzcloud.club'
// export const payServerName = 'https://paycloud.test.szzcloud.club'
// export const couponUrl = 'https://coupon.test.szzcloud.club'
// export const emqxServerName = 'wss://parkcloud.test.szzcloud.club'
// export const iotServerName = 'https://iot.test.szzcloud.club'
// export const cityCloudUrl = 'http://citycloud.test.szzcloud.club'
// export const chargeServeUrl = 'https://charge.test.szzcloud.club'
// export const reqMqCloudUrl = 'https://reqmqcloud.test.szzcloud.club'

// 生产环境服务地址映射。未匹配到访问域名时，默认使用现有的 szzcloud 配置。
const defaultHost = 'paycloud.szzcloud.club'
const serverConfigMap = {
  'paycloud.szzcloud.club': {
    parkcloudServerName: 'https://parkcloud.szzcloud.club',
    payServerName: 'https://paycloud.szzcloud.club',
    couponUrl: 'https://coupon.szzcloud.club',
    emqxServerName: 'wss://parkcloud.szzcloud.club',
    iotServerName: 'https://iot.szzcloud.club',
    cityCloudUrl: 'https://citycloud.nayuntec.cn',
    chargeServeUrl: 'https://charge.szzcloud.club',
    reqMqCloudUrl: 'https://reqmqcloud.nayuntec.cn'
  },
  'paycloud.nayuntec.cn': {
    parkcloudServerName: 'https://prs.nayuntec.cn',
    payServerName: 'https://paycloud.nayuntec.cn',
    couponUrl: 'https://coupon.nayuntec.cn',
    emqxServerName: 'wss://prs.nayuntec.cn',
    iotServerName: 'https://iot.nayuntec.cn',
    cityCloudUrl: 'https://citycloud.nayuntec.cn',
    chargeServeUrl: 'https://charge.nayuntec.cn',
    reqMqCloudUrl: 'https://reqmqcloud.nayuntec.cn'
  }
}
const currentHost = typeof window !== 'undefined' && window.location
  ? window.location.hostname
  : defaultHost
const serverConfig = serverConfigMap[currentHost] || serverConfigMap[defaultHost]

export const parkcloudServerName = serverConfig.parkcloudServerName
export const payServerName = serverConfig.payServerName
export const couponUrl = serverConfig.couponUrl
export const emqxServerName = serverConfig.emqxServerName
export const iotServerName = serverConfig.iotServerName
export const cityCloudUrl = serverConfig.cityCloudUrl
export const chargeServeUrl = serverConfig.chargeServeUrl
export const reqMqCloudUrl = serverConfig.reqMqCloudUrl

// 银泰城
// export const serverName = location.origin
// export const parkcloudServerName = serverName + '/prs'
// export const payServerName = serverName
// export const emqxServerName = 'wss://' + location.host
// export const iotServerName = serverName + '/iot'

// export const couponUrl = serverName + '/coupon'
// export const cityCloudUrl = serverName + '/citycloud'
// export const chargeServeUrl = serverName + '/charge'
// export const reqMqCloudUrl = serverName + '/reqmq'

// 展示广告 ‘1’云纵 ‘2’伯斯特 ‘3’P云 ‘4’群蜂
// 必须是字符串 1，2，3，4
export const adFlag = '1'
